import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useFilter } from "../../Context/FilterContext";
import ajaxInventoryReports from "../../util/remote/ajaxInventoryReports";
const SingleStationInventoryMonthlyFlow = () => {
  const { toggleFilter, filterVisible } = useFilter();
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [inventoryData, setInventoryData] = useState({});
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const formatNumber = (num) => {
    if (!num) return "0";
    return Number(num).toLocaleString();
  };
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString();
  };
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
  const fetchSales = async () => {
    setLoading(true);
    const compactMonth = month.replace("-", "");
    const data = {
      station_id: station_idd,
      month: compactMonth,
    };
    const response =
      await ajaxInventoryReports.single_station_stock_monthly_flow(data);
    setLoading(false);
    if (response.status === "OK") {
      setInventoryData(response.details); // <-- your new structure
    } else {
      toast.error(response.message || "Failed to load inventory flow");
    }
  };
  useEffect(() => {
    fetchSales();
  }, [month]);
  return (
    <AppContainer
      title="Monthly Inventory Flow"
      previousPageTitle="Dashboard"
      actions={[
        {
          label: "filter",
          icon: "fa-solid fa-filter",
          className: "btn btn-warning btn-sm",
          onClick: () => toggleFilter(),
        },
      ]}
    >
      <div className="container-fluid">
        <Toaster />
        {/* FILTER SECTION */}
        {filterVisible && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="row g-3 align-items-end">
                      <div className="col-lg-3">
                        <label className="form-label fw-semibold">Month</label>
                        <input
                          type="month"
                          className="form-control"
                          value={month}
                          onChange={(e) => setMonth(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-3 d-flex justify-content-end">
                        <button
                          className="btn btn-primary btn-sm m-2"
                          onClick={fetchSales}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* LOADING */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">Loading...</div>
        ) : Object.keys(inventoryData).length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Inventory Flow Found For This Month
          </div>
        ) : (
          <>
            {Object.values(inventoryData).map((fuel, index) => (
              <div className="row mb-4" key={fuel.fuel_id}>
                <div className="col-12">
                  <div className="card shadow-sm">
                    <div className="card-body">
                      <h5 className="fw-bold text-primary">
                        {index + 1}. {fuel.fuel_name}
                      </h5>
                      {/* OPENING STOCK */}
                      <div className="alert alert-secondary mt-3">
                        <strong>
                          Opening Stock:&nbsp;&nbsp;&nbsp;&nbsp;
                          {formatNumber(fuel.opening.balance)}
                          (litres)
                        </strong>
                      </div>
                      {/* TRANSACTIONS TABLE */}
                      <div className="table-responsive mt-3">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Date</th>
                              <th>Type</th>
                              <th>QTY In</th>
                              <th>QTY Out</th>
                              <th>Running Balance</th>
                            </tr>
                          </thead>
                          <tbody>
                            {fuel.transactions.map((t, idx) => (
                              <tr key={t.id}>
                                <td>{idx + 1}</td>
                                <td>{formatDate(t.action_date)}</td>
                                <td className="text-capitalize">
                                  {t.trans_type}
                                </td>
                                <td>{formatNumber(t.quantity_in)}</td>
                                <td>{formatNumber(t.quantity_out)}</td>
                                <td>
                                  <strong>{formatNumber(t.balance)}</strong>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </AppContainer>
  );
};
export default SingleStationInventoryMonthlyFlow;
